
   const timeZoneSelect=[
        {
            value: "+12",
            label: "东西十二区 ( UTC +12 )"
        },
        {
            value: "+11",
            label: "东十一区 ( UTC +11 )"
        },
        {
            value: "+10",
            label: "东十区 ( UTC +10 )"
        },
        {
            value: "+9",
            label: "东九区 ( UTC +9 )"
        },
        {
            value: "+8",
            label: "东八区 ( UTC +8 )"
        },
        {
            value: "+7",
            label: "东七区 ( UTC +7 )"
        },
        {
            value: "+6",
            label: "东六区 ( UTC +6 )"
        },
        {
            value: "+5",
            label: "东五区 ( UTC +5)"
        },
        {
            value: "+4",
            label: "东四区 ( UTC +4 )"
        },
        {
            value: "+3",
            label: "东三区 ( UTC +3 )"
        },
        {
            value: "+2",
            label: "东二区 ( UTC +2 )"
        },
        {
            value: "+1",
            label: "东一区 ( UTC +1 )"
        },
        {
            value: "0",
            label: "中时区 ( UTC +0 )"
        },
        {
            value: "-1",
            label: "西一区 ( UTC -1 )"
        },
        {
            value: "-2",
            label: "西二区 ( UTC -2 )"
        },
        {
            value: "-3",
            label: "西三区 ( UTC -3 )"
        },
        {
            value: "-4",
            label: "西四区 ( UTC -4 )"
        },
        {
            value: "-5",
            label: "西五区 ( UTC -5 )"
        },
        {
            value: "-6",
            label: "西六区 ( UTC -6 )"
        },
        {
            value: "-7",
            label: "西七区 ( UTC -7 )"
        },
        {
            value: "-8",
            label: "西八区 ( UTC -8 )"
        },
        {
            value: "-9",
            label: "西九区 ( UTC -9 )"
        },
        {
            value: "-10",
            label: "西十区 ( UTC -10 )"
        },
        {
            value: "-11",
            label: "西十一区 ( UTC -11 )"
        }
    ]


    export default timeZoneSelect

